import { render, staticRenderFns } from "./ShoppingListProductActions.vue?vue&type=template&id=56aca696&"
import script from "./ShoppingListProductActions.vue?vue&type=script&lang=js&"
export * from "./ShoppingListProductActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports